export var ImagePathsUnpreserved = [
  {
    type: "directory",
    name: "008de32d-b313-481b-a37b-5f4b6929756f",
    contents: [
      {
        type: "file",
        name: "Kláτterec-nad-Oh²í_Benediktíni_02_07.07.2023.jpg",
      },
      { type: "file", name: "Kláτterec-nad-Oh²í_Benediktíni_07.07.2023.jpg" },
    ],
  },
  {
    type: "directory",
    name: "02adcc66-5a2e-467a-b9f4-b1195478bb89",
    contents: [
      {
        type: "file",
        name: "Praha-Nové-M╪sto_Johanité_Benediktíni_Ivanité_NEDOCHOVANÉ_08.04.2022.jpg",
      },
    ],
  },
  {
    type: "directory",
    name: "0efaf78b-d168-4ab0-8b94-a077258b816e",
    contents: [
      {
        type: "file",
        name: "Praha-Bernardinum-II._cisterciáci_NEDOCHOVANÉ_09.04.2022.jpg",
      },
    ],
  },
  {
    type: "directory",
    name: "1b9d0df5-05f9-43ed-82bd-135a81cdfae1",
    contents: [{ type: "file", name: "Most_Piaristé_08.07.2023.jpg" }],
  },
  {
    type: "directory",
    name: "1eff453b-3975-4926-8e63-c8559d330a46",
    contents: [{ type: "file", name: "Klenov_Templá²i_12.08.2023.jpg" }],
  },
  {
    type: "directory",
    name: "2097d571-f1b0-483a-923a-4ba251a55de1",
    contents: [
      { type: "file", name: "Valtice_Minorité_Frantiτkáni_17.06.2023.jpg" },
    ],
  },
  {
    type: "directory",
    name: "2c09fd49-6da2-4a91-893a-efe8f09e024b",
    contents: [
      { type: "file", name: "¼eské-Bud╪jovice_Kapucíni_19.09.2022.jpg" },
    ],
  },
  {
    type: "directory",
    name: "2cc358ad-5837-496c-90f9-b85d70b24eb7",
    contents: [
      {
        type: "file",
        name: "Hradec-Králové_n╪meƒtí-rytí²i_NEDOCHOVANÉ_16.05.2021.jpg",
      },
    ],
  },
  {
    type: "directory",
    name: "30d0b23b-5990-46ff-ae4e-ba42addb3385",
    contents: [
      { type: "file", name: "Solnice_Cyriaci_NEDOCHOVANÉ_30.12.2021.jpg" },
    ],
  },
  {
    type: "directory",
    name: "34e1b7ad-7831-49ef-9b08-1814b9a7a02f",
    contents: [
      {
        type: "file",
        name: "Praha-sv.-K²íº_Cyriaci_Pauláni_NEDOCHOVANÉ_10.04.2022.jpg",
      },
    ],
  },
  {
    type: "directory",
    name: "422d33d0-54c7-44b4-8f02-d3f661371a6e",
    contents: [{ type: "file", name: "Most_Kapucíni_08.07.2023.jpg" }],
  },
  {
    type: "directory",
    name: "474bc424-cc9c-46b9-b66e-4cd4ee494eaa",
    contents: [
      { type: "file", name: "Najτtejn_N╪meƒtí-rytí²i_02_08.07.2023.jpg" },
      { type: "file", name: "Najτtejn_N╪meƒtí-rytí²i_08.07.2023.jpg" },
    ],
  },
  {
    type: "directory",
    name: "499dfee0-abc3-4ef7-b705-9f093b4f219e",
    contents: [
      {
        type: "file",
        name: "Praha_sv.-Má²í-Magdalena_Dominikáni_NEDOCHOVANÉ_09.04.2022.jpg",
      },
    ],
  },
  {
    type: "directory",
    name: "4a398c21-2517-4f4b-9dd0-634424edb373",
    contents: [
      {
        type: "file",
        name: "Praha-sv.-Lazar_Vojensk∞-a-τpitální-²ád-rytí²à sv. Lazara Jeruza.jpg",
      },
      {
        type: "file",
        name: "Praha-sv.-Lazar_Vojensk∞-a-τpitální-²ád-rytí²à sv. Lazara Jeruzalémského,NEDOCHOVANÉ_09.04.2022.jpg",
      },
    ],
  },
  {
    type: "directory",
    name: "4a442084-5d75-4ee4-a5f2-84b6182a2d60",
    contents: [
      { type: "file", name: "Chot╪bo²_Cisterciáci_NEDOCHOVANÉ_04.07.2021.jpg" },
    ],
  },
  {
    type: "directory",
    name: "4fd0f4ae-2010-4ec9-a5a2-8cc08d5e1f1d",
    contents: [
      {
        type: "file",
        name: "Olomouc_Augustiniáni-kanovníci_nedochované_1.-máje_16.06.2021.jpg",
      },
    ],
  },
  {
    type: "directory",
    name: "5372c084-bf86-483c-babc-f9a9d2184653",
    contents: [
      {
        type: "file",
        name: "Olomouc_Kapucíni_Pavelƒákova_NEDOCHOVANÉ_07.08.2022.jpg",
      },
    ],
  },
  {
    type: "directory",
    name: "53b56149-b526-438c-b8b9-e51e9a876c53",
    contents: [
      { type: "file", name: "Polná_N╪meƒtí-rytí²i_NEDOCHOVANÉ_04.07.2021.jpg" },
    ],
  },
  {
    type: "directory",
    name: "5b019aa1-7e9b-4094-95d5-59c8a7f8ce9c",
    contents: [
      {
        type: "file",
        name: "Lysá-nad-Labem_Ivanité_poustevna-v-lese_01.05.2023.jpg",
      },
    ],
  },
  {
    type: "directory",
    name: "606615ed-197c-4ba8-adb7-f1baf234357e",
    contents: [{ type: "file", name: "ªatec_Minorité_07.07.2023.jpg" }],
  },
  {
    type: "directory",
    name: "61a9b2a6-fd60-4125-b2c7-3043b4598c20",
    contents: [
      { type: "file", name: "B∞ƒkovice_N╪meƒtí-rytí²i_02_10.07.2023.jpg" },
      { type: "file", name: "B∞ƒkovice_N╪meƒtí-rytí²i_10.07.2023.jpg" },
    ],
  },
  {
    type: "directory",
    name: "65be1105-aa18-4dcd-8f67-39a21eb637bf",
    contents: [
      { type: "file", name: "Praha_Cisterciáci_Plaská_01.03.2023.jpg" },
    ],
  },
  {
    type: "directory",
    name: "6b03344a-0838-44f3-a2ca-35adaefa346c",
    contents: [
      {
        type: "file",
        name: "Brno-sv.-Vít_Johanité_ⁿád-sv.ducha_NEDOCHOVANÉ.jpg",
      },
    ],
  },
  {
    type: "directory",
    name: "6c3fdb44-4907-4cb6-9e31-22cf1f7e26e3",
    contents: [
      {
        type: "file",
        name: "Hradec-Králové_dominikáni_NEDOCHOVANÉ_21.02.2021.jpg",
      },
    ],
  },
  {
    type: "directory",
    name: "6e539ed0-016a-4fc2-98ba-1228f82d3312",
    contents: [
      {
        type: "file",
        name: "Brno_Veve²í-ul._Augustiniáni_nedochované_14.08.2021.jpg",
      },
    ],
  },
  {
    type: "directory",
    name: "6f464a4a-8eea-4b4e-a6a5-dcf40fe54c53",
    contents: [{ type: "file", name: "Jiτt╪rpy_Jezuité_10.07.2023.jpg" }],
  },
  {
    type: "directory",
    name: "74b85bf0-3ab1-4230-8a4a-a5770cddb994",
    contents: [
      {
        type: "file",
        name: "Brno-sv.-Frantiτek_Kapucíni_NEDOCHOVANÉ_14.08.2021.jpg",
      },
    ],
  },
  {
    type: "directory",
    name: "7dc3d919-d06a-429f-84d6-449c6e0ade1b",
    contents: [
      {
        type: "file",
        name: "Stará-Paseƒnice_Benediktíni_pouze-k²íº_23.09.2022.jpg",
      },
    ],
  },
  {
    type: "directory",
    name: "90625ef0-6bf3-4773-af8b-aed777dc2cee",
    contents: [
      {
        type: "file",
        name: "Praha-sv.-Benedikt_N╪meƒtí-rytí²i_Premostráti_NEDOCHOVANÉ_09.04.2022.jpg",
      },
    ],
  },
  {
    type: "directory",
    name: "912c5e2e-df3e-4805-bf73-e4ecb8d85ee3",
    contents: [
      {
        type: "file",
        name: "Mladá-Boleslav_Johanité-_NEDOCHOVANÉ_29.05.2021.jpg",
      },
    ],
  },
  {
    type: "directory",
    name: "924c61f4-6782-4024-a9de-6f97c19046b6",
    contents: [{ type: "file", name: "ªatec_Benediktíni_07.07.2023.jpg" }],
  },
  {
    type: "directory",
    name: "98509988-6777-4421-990e-5c326c41e486",
    contents: [
      {
        type: "file",
        name: "Hradec-Králové-sv.-Anna_minorité_NEDOCHOVANÉ_27.02.2021.jpg",
      },
    ],
  },
  {
    type: "directory",
    name: "99a5f6fd-34f8-4e07-bb56-ad0d7bf76bf8",
    contents: [
      {
        type: "file",
        name: "Plzeσ-sv.-Má²í-Magdalena-N╪meƒtí-rytí²i_NEDOCHOVANÉ_24.09.2022.jpg",
      },
    ],
  },
  {
    type: "directory",
    name: "a35e730a-d777-4db2-9f56-25a5c57526b4",
    contents: [{ type: "file", name: "Louny_Dominikáni_06.07.2023.jpg" }],
  },
  {
    type: "directory",
    name: "afcd9e50-0f0e-4c43-bfe8-7b5653314879",
    contents: [
      {
        type: "file",
        name: "Praha-bl.-Sneºka_K²íºovnící-s-ƒervenou-hv╪zdou_NEDOCHOVANÉ_09.04.2022.jpg",
      },
    ],
  },
  {
    type: "directory",
    name: "b4345bdd-1b34-46b1-a469-5485d7298c53",
    contents: [
      { type: "file", name: "Krupka_Jezuité_Frantiτkáni_09.07.2023.jpg" },
    ],
  },
  {
    type: "directory",
    name: "b5625f02-33c8-441d-af4b-1e099e1f6e00",
    contents: [
      {
        type: "file",
        name: "Krom╪²íº-Nejsv╪t╪jτí-Trojice_Frantiτkáni_NEDOCHOVANÉ_27.12.2021.jpg",
      },
    ],
  },
  {
    type: "directory",
    name: "c076c752-734d-499a-9b8a-024f9abeee15",
    contents: [
      {
        type: "file",
        name: "Byst²ice-nad-Pernτtejnem_Minorité_09.04.2023.jpg",
      },
    ],
  },
  {
    type: "directory",
    name: "c5dc3920-b793-406d-bd1e-e882f35939ae",
    contents: [
      { type: "file", name: "Brloh_Augustiniáni-kanovníci_06.07.2023.jpg" },
    ],
  },
  {
    type: "directory",
    name: "ca3f7cec-d5b2-4fdd-87ae-96a8ee5d6121",
    contents: [
      { type: "file", name: "Most_Piaristé_OC-Central_08.07.2023.jpg" },
    ],
  },
  {
    type: "directory",
    name: "cba790fb-a023-4e53-9640-11a30d3b0d08",
    contents: [
      {
        type: "file",
        name: "Brno-sv.-Bernardin_Frantiτkáni_NEDOCHOVANÉ_14.08.2021.jpg",
      },
    ],
  },
  {
    type: "directory",
    name: "d2bc3451-0a39-486b-aa2d-22f852a266e3",
    contents: [
      {
        type: "file",
        name: "Drobovice_28_N╪meƒtí-Rytí²i_NEDOCHOVANÉ_27.02.202.jpg",
      },
    ],
  },
  {
    type: "directory",
    name: "e1668f1c-d931-4d6c-801e-744019d294cf",
    contents: [
      {
        type: "file",
        name: "Písek_K²íºovníci-s-ƒervenou-hv╪zdou_NEDOCHOV╡NO_21.09.2022.jpg",
      },
    ],
  },
  {
    type: "directory",
    name: "e2c36e4e-62ef-40c7-bd08-72a45c9d088e",
    contents: [
      {
        type: "file",
        name: "Mariánská-u-Jáchymova_kapucíni_NEDOCHOVANÉ_26.09.2022.jpg",
      },
    ],
  },
  {
    type: "directory",
    name: "e436c970-08c3-46a5-934d-1415aeb9a6a6",
    contents: [
      { type: "file", name: "Dvorek_Salesiáni_NEDOCHOVANÉ_04.07.2021.jpg" },
    ],
  },
  {
    type: "directory",
    name: "ef356637-55f9-47c6-8765-35cad03a8297",
    contents: [
      { type: "file", name: "P²ibice_Johanité_02_17.06.2023.jpg" },
      { type: "file", name: "P²ibice_Johanité_17.06.2023.jpg" },
    ],
  },
  {
    type: "directory",
    name: "fcc9ee60-e7da-4f9e-b4e3-8188eef3664b",
    contents: [
      {
        type: "file",
        name: "Most_K²iºovníci-s-ƒerven∞m-k²íºem_08.07.2023.jpg",
      },
      {
        type: "file",
        name: "Most_K²iºovníci-s-ƒervenou-hv╪zdou_k²íºem_08.07.2023.jpg",
      },
    ],
  },
  {
    type: "directory",
    name: "fcfa37cd-dca3-468f-9846-579c4b4104d7",
    contents: [
      { type: "file", name: "Jihlava_Kapucíni_NEDOCHOVANÉ_17.04.2021.jpg" },
    ],
  },
  {
    type: "directory",
    name: "fdfa9514-056c-4eab-a26f-ffeab6f41b17",
    contents: [
      {
        type: "file",
        name: "Θstí-nad-Labem_K²íºovníci-s-ƒervenou-hv╪zdou_09.07.2023.jpg",
      },
    ],
  },
];
